import { Box } from "@mui/material";
import { StriimButton, StriimModal, StriimTypography } from "@striim/striim-ui";
import React from "react";
import { Close } from "../../../generic/icon/customIcons";

const styles = {
    dialogFooter: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    },
    content: {
        padding: 3
    }
};

interface AIAgentsDialogProps {
    isOpen: boolean;
    onClose: () => void;
}

const AIAgentsDialog: React.FC<AIAgentsDialogProps> = ({ isOpen, onClose }) => {
    return (
        <Box>
            <StriimModal
                isVisible={isOpen}
                size="medium"
                autoHeight
                onCancel={onClose}
                dialogProps={{
                    sx: { ".MuiDialog-paper": { width: "900px", minWidth: "800px", height: "500px !important" } }
                }}
                titleContent={
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <StriimTypography variant={"h2"}>AI Agents in Striim</StriimTypography>
                        <StriimButton size="small" onClick={onClose}>
                            <Close fontSize={24} />
                        </StriimButton>
                    </div>
                }
                footerContent={
                    <div sx={styles.dialogFooter}>
                        <div></div>
                        <div>
                            <StriimButton variant="primary" data-test-id="ai-agents-done-button" onClick={onClose}>
                                Done
                            </StriimButton>
                        </div>
                    </div>
                }
            >
                <Box sx={styles.content} alignContent={"center"} alignItems={"center"} textAlign={"center"}>
                    <StriimTypography variant="body1" sx={{ width: "800px" }}>
                        Power your data pipelines with real-time intelligence using Striim AI agents. Leverage Euclid
                        for vector embeddings, Forseer for time-series forecasting and anomaly detection, and Sentinel
                        for sensitive data governance. Seamlessly integrate these AI components directly from the Flow
                        Designer to infuse your data flows with real-time, AI-driven decisions.
                    </StriimTypography>
                    <br />
                    <br />
                    <img src="/app/images/ai_agents.gif" alt="AI Agents in Striim" />
                    {/* Add more content for AI Agents dialog here */}
                </Box>
            </StriimModal>
        </Box>
    );
};

export default AIAgentsDialog;
